import { Controller } from "@hotwired/stimulus"

// Toggles visibility of expanded content (e.g., interest lists, edit forms).
//
// Usage:
//   <div data-controller="toggle">
//     <div data-toggle-target="content" class="hidden">...</div>
//     <button data-action="click->toggle#toggle" data-toggle-target="button">Show all</button>
//     <div data-toggle-target="defaults">...</div>  <!-- optional: hidden when content shown -->
//   </div>
//
export default class extends Controller {
  static targets = ["content", "button", "buttonLabel", "buttonIcon", "defaults"]
  static values = {
    expanded: { type: Boolean, default: false },
    showLabel: { type: String, default: "" },
    hideLabel: { type: String, default: "" },
    showIcon: { type: String, default: "" },
    hideIcon: { type: String, default: "" }
  }

  connect() {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", String(this.expandedValue))
    // Store the original icon SVG so we can restore it
    if (this.hasButtonIconTarget) {
      this._showIconHTML = this.buttonIconTarget.innerHTML
    }
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.contentTarget.classList.toggle("hidden", !this.expandedValue)

    if (this.hasDefaultsTarget) {
      this.defaultsTarget.classList.toggle("hidden", this.expandedValue)
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(this.expandedValue))
      const showText = this.showLabelValue || "Show all"
      const hideText = this.hideLabelValue || "Show less"
      const labelTarget = this.hasButtonLabelTarget ? this.buttonLabelTarget : this.buttonTarget
      labelTarget.textContent = this.expandedValue ? hideText : showText
    }

    if (this.hasButtonIconTarget && this.hideIconValue) {
      this.buttonIconTarget.innerHTML = this.expandedValue
        ? this.hideIconValue
        : this._showIconHTML
    }
  }
}
